import React from 'react';
import DiagramQ2Workflow from '../diagrams/DiagramQ2Workflow';
import DiagramEskalationQ2 from '../diagrams/DiagramEskalationQ2';

export default function SectionQ2Supplier() {
  return (
    <div className="space-y-4" data-testid="section-q2-supplier">
      <div>
        <h3 className="text-base font-bold text-slate-800 mb-1">Q2 — Lieferantenreklamation</h3>
        <p className="text-xs text-slate-500">Prozess für die strukturierte Kommunikation mit Lieferanten bei Qualitätsabweichungen an Zukaufteilen, Wareneingang oder Lohnfertigung.</p>
      </div>

      <div className="grid sm:grid-cols-3 gap-2">
        <div className="p-2.5 rounded-lg bg-blue-50 border border-blue-200 text-xs">
          <div className="font-semibold text-blue-900 mb-1">Szenario 1: aus Q1</div>
          <div className="text-slate-600">Kundenreklamation zeigt, dass Zukauf-Fehler vorliegt → Q2 aus Q1 ableiten (Rückfluss am Ende).</div>
        </div>
        <div className="p-2.5 rounded-lg bg-amber-50 border border-amber-200 text-xs">
          <div className="font-semibold text-amber-900 mb-1">Szenario 2: Wareneingang</div>
          <div className="text-slate-600">WQS prüft Lieferung, entdeckt Abweichung → Q2 direkt, ohne Q1-Kontext.</div>
        </div>
        <div className="p-2.5 rounded-lg bg-purple-50 border border-purple-200 text-xs">
          <div className="font-semibold text-purple-900 mb-1">Szenario 3: Lohnfertigung</div>
          <div className="text-slate-600">Zulieferer bearbeitet Halbfertigprodukt → Qualitätsabweichung festgestellt.</div>
        </div>
      </div>

      <DiagramQ2Workflow />

      <div>
        <h4 className="text-sm font-bold text-slate-800 mb-2">Ablauf-Details</h4>
        <ol className="text-xs space-y-1.5 ml-4 list-decimal text-slate-700">
          <li><strong>Anlage</strong> durch WQS oder ZQM mit Pflichtfeldern (Lieferant, Material, Frist, Report-Typ).</li>
          <li><strong>KI-Check</strong> (p18): identifiziert betroffenen Zukauf-Lieferanten automatisch aus Q1-Daten.</li>
          <li><strong>Versand</strong> per E-Mail mit eindeutigem Token-Link → Lieferant öffnet Portal (kein Login nötig).</li>
          <li><strong>Bearbeitung</strong> durch Lieferant: 4D- oder 8D-Report ausfüllen, PDF hochladen.</li>
          <li><strong>KI-Bewertung</strong> (p19): Score 0-100 für eingereichten Report.</li>
          <li><strong>Freigabe</strong> durch interne ZQM: akzeptieren / zur Überarbeitung zurück.</li>
          <li><strong>Kosten-Erfassung</strong> (p21): 7 Kostenarten von KI vorgeschlagen.</li>
          <li><strong>Rückfluss zu Q1</strong>: D4/D5/D7-Vorschläge werden in Ursprungs-Q1 übernommen.</li>
          <li><strong>Schließen</strong>: Q1 kann nur geschlossen werden, wenn alle Q2 abgeschlossen sind.</li>
        </ol>
      </div>

      <DiagramEskalationQ2 />

      <div className="p-3 rounded-lg bg-slate-50 border border-slate-200 text-xs text-slate-700">
        <strong className="block mb-1 text-slate-900">Proaktive Erinnerungen (Rev.200+):</strong>
        Das System sendet dem Lieferanten automatisch <strong>3 Werktage vor Frist-Ablauf</strong> eine
        Erinnerungs-E-Mail. Bei Überschreitung läuft die 3-stufige Eskalation (L1 Einkauf → L2 Einkaufsleitung → L3 Management).
      </div>
    </div>
  );
}
